import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import CommissionTransactionListScreen from './screens/CommissionTransactionListScreen';

function ManageCommissionTransaction(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-4 pb-4 mt-4">
        <Routes>
          <Route path="" element={<CommissionTransactionListScreen />} />
          <Route path="*" element={<>Not found</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ManageCommissionTransaction;
